// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__6VuOm","AuthForm":"Auth_AuthForm__3oC3B"};